export default function displayName(SomeComponent) {
  return SomeComponent.displayName || SomeComponent.name || "Component"
}
